import { MEDIA_QUERY } from '../../constants/responsive.mjs';
import { px2rem } from '../../helpers/rem.mjs';
import styled, { css } from 'styled-components';

var Media = styled.div.withConfig({
  displayName: "Media",
  componentId: "sc-12djohy-0"
})(["z-index:", ";opacity:0;transition-delay:", ";transition:", ";", ";@media ", "{padding:0 ", ";}"], function (props) {
  return props.theme.zIndexes["default"];
}, function (props) {
  return props.transition ? "500ms" : undefined;
}, function (props) {
  return props.transition ? "opacity 500ms" : undefined;
}, function (props) {
  return props.disableMediaOpacity && props.mediaOpacity === 0 ? css(["display:none;"]) : null;
}, MEDIA_QUERY.ONLY_MOBILE, px2rem(16));
var SkeletonContainer = styled.div.withConfig({
  displayName: "SkeletonContainer",
  componentId: "sc-12djohy-1"
})(["position:absolute;left:0;top:0;width:100%;height:100%;display:flex;"]);
var BlurHash = styled.div.withConfig({
  displayName: "BlurHash",
  componentId: "sc-12djohy-2"
})(["z-index:", ";"], function (props) {
  return props.theme.zIndexes.below;
});
var Wrapper = styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "sc-12djohy-3"
})(["position:relative;z-index:", ";", "{position:absolute;width:100%;height:100%;top:0;left:0;bottom:0;right:0;}"], function (props) {
  return props.theme.zIndexes["default"];
}, BlurHash);

export { BlurHash, Media, SkeletonContainer, Wrapper };
